module.exports = __webpack_public_path__ + "f0180f8935bc88a5c02659d37646e051.png";